"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StickyNav_1 = __importDefault(require("../../components/StickyNav"));
new StickyNav_1.default('header.desktop, header.mobile');
